import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";
import { ModalState } from "@app/enums/modal";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { useModal } from "@app/hooks";
import { Card } from "./components/card/Card";
import { useImages } from "./useImages";
import { CardTranslation } from "./types";

export const CommunicationWays: FC = () => {
  const { onChangeModalState } = useModal();
  const images = useImages();
  const { t } = useTranslation("p_contact");
  const cardTranslations = t("communication_ways", {
    returnObjects: true,
  }) as CardTranslation[];

  const openChatbase = () => {
    const bubble = document.getElementById("chatbase-bubble-button");

    if (bubble) {
      bubble.click();
    } else {
      console.warn("Chatbase bubble button not found!");
    }
  };

  const contactWays = [
    {
      imageData: images[0],
      imageAlt: "Book a call",
      title: cardTranslations[0].title,
      text: cardTranslations[0].text,
      buttonLabel: cardTranslations[0].button,
      onButtonClick: () => onChangeModalState(ModalState.SCHEDULE_A_CALL),
    },
    {
      imageData: images[1],
      imageAlt: "Write to us",
      title: cardTranslations[1].title,
      text: cardTranslations[1].text,
      buttonLabel: cardTranslations[1].button,
      onButtonClick: () => onChangeModalState(ModalState.CONTACT_US),
    },
    {
      imageData: images[2],
      imageAlt: "Start a chat",
      title: cardTranslations[2].title,
      text: cardTranslations[2].text,
      buttonLabel: cardTranslations[2].button,
      onButtonClick: openChatbase,
    },
  ];

  return (
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <div
        className={classNames(
          "grid grid-cols-1 gap-y-10 px-5",
          "md:grid-cols-2 md:gap-x-5",
          "lg:grid-cols-3 lg:px-16",
          "xl:gap-x-10 xl:px-24",
          "2xl:gap-12",
        )}
      >
        {contactWays.map((contactWay, index) => (
          <Card key={index} {...contactWay} />
        ))}
      </div>
    </Fade>
  );
};
